import {
  Grid,
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Button
} from '@mui/material';
import DateRange from 'src/components/common/DateRange';
import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { contractNameMapper, corpNameMapper } from './CashlesInfoText';

function CashlessToolbar({
  refButtonAction,
  setToolBarOptions,
  setSearchOptions
}) {
  let allCorps = {
    11185545: true,
    1027866: true
  };
  let allServices = {
    10386: true,
    10389: true,
    10401: true,
    12553: true,
    10390: true,
    13973: true,
    10846: true
  };
  const [corporates, setCorporates] = React.useState(allCorps);
  const [services, setServices] = React.useState(allServices);
  let dateRangeValue = [];
  function handleFilter(value) {
    dateRangeValue = value;
  }

  const handleCorporateChange = (e) => {
    const newSelection = e.target.value;
    Object.keys(allCorps).forEach((ele) => {
      if (newSelection.includes(ele)) {
        allCorps[ele] = true;
      } else {
        allCorps[ele] = false;
      }
    });
    setCorporates(allCorps);
  };

  const handleServicesChange = (e) => {
    const newSelection = e.target.value;
    Object.keys(allServices).forEach((ele) => {
      if (newSelection.includes(ele)) {
        allServices[ele] = true;
      } else {
        allServices[ele] = false;
      }
    });
    setServices(allServices);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={3}>
        <DateRange
          helperTextValue={'Fulfilled-Date'}
          boxsize="small"
          onDateChange={(value) => {
            handleFilter(value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <FormControl size="small" fullWidth variant="outlined">
          <InputLabel>Corporates</InputLabel>
          <Select
            multiple
            id="corporate-name"
            value={Object.keys(corporates).filter((ele) => {
              if (corporates[ele]) {
                return true;
              }
              return false;
            })}
            onChange={handleCorporateChange}
            renderValue={(selected) => {
              return selected.map((ele) => corpNameMapper(ele)).join(', ');
            }}
            label="corporate"
          >
            {Object.keys(allCorps).map((val) => (
              <MenuItem sx={{ py: 0 }} value={val} key={val}>
                <Checkbox
                  checked={corporates[val]}
                  color="primary"
                  size="small"
                />
                <ListItemText primary={corpNameMapper(val)} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={2}>
        <FormControl size="small" fullWidth variant="outlined">
          <InputLabel>Services</InputLabel>
          <Select
            multiple
            id="service-name"
            value={Object.keys(services).filter((ele) => {
              if (services[ele]) {
                return true;
              }
              return false;
            })}
            onChange={handleServicesChange}
            renderValue={(selected) => {
              return selected
                .map((ele) => contractNameMapper(ele, 'Other'))
                .join(', ');
            }}
            label="service"
          >
            {Object.keys(allServices).map((val) => (
              <MenuItem sx={{ py: 0 }} value={val} key={val}>
                <Checkbox
                  checked={services[val]}
                  color="primary"
                  size="small"
                />
                <ListItemText primary={contractNameMapper(val, 'Other')} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item>
        <Tooltip title="Submit">
          <Button
            variant="outlined"
            onClick={() => {
              setToolBarOptions(dateRangeValue, corporates, services);
              refButtonAction();
            }}
          >
            Submit
            <RefreshIcon />{' '}
          </Button>
        </Tooltip>
      </Grid>
      <Grid item sx={12} container style={{ paddingBottom: '10px' }}>
        <Grid item sm={3}>
          <FormControl size="small" variant="filled" fullWidth>
            <OutlinedInput
              id="outlined-search"
              sx={{
                boxShadow: 0,
                bgcolor: '#f2f2f2'
              }}
              labelWidth={0}
              onChange={(event) => {
                setSearchOptions(event.target.value);
              }}
              placeholder={`Search for OrderId`}
            />
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CashlessToolbar;
